import * as React from 'react';
import { Button, TextInput, TouchableOpacity } from 'react-native';
import { AppStyles } from '../style/Styles';
import { LessonBlockResponse } from '../types/Types';
import {
  firebaseCurrentUser,
  uploadResponse
} from '../utility/firebaseFunctions';
import { uuidv4 } from '../utility/lessonKeeperFunctions';
import { useKeyPress } from '../utility/reactUtility';
import { Text, View } from './Themed';

export const CreateResponseView: React.FunctionComponent<{
  lessonOwnerID: string;
  blockID: string;
  lessonID: string;
}> = (props) => {
  const uid = firebaseCurrentUser();
  if (!uid) {
    return null;
  }

  const generateBlankResponse = () => ({
    id: uuidv4(),
    blockID: props.blockID,
    creatorID: uid,
    modifiedDate: new Date(),
    fromInstructor: uid === props.lessonOwnerID,
    textContent: '',
  });

  const [response, setResponse] = React.useState<LessonBlockResponse>(
    generateBlankResponse()
  );

  const [showField, setShowField] = React.useState(false);

  useKeyPress('Escape', () => setShowField(false));

  const submitResponse = async () => {
    console.log('Submit response');

    await uploadResponse(
      { ...response, modifiedDate: new Date() },
      props.lessonOwnerID,
      props.lessonID
    );

    setShowField(false);
    setResponse(generateBlankResponse());
  };

  return (
    <View style={{ backgroundColor: 'clear' }}>
      {!showField && (
        <TouchableOpacity
          onPress={() => setShowField(true)}
          style={AppStyles.replyButton}
        >
          <Text>Reply</Text>
        </TouchableOpacity>
      )}
      {showField && (
        <>
          <TextInput
            multiline={true}
            value={response.textContent}
            onChangeText={(text) =>
              setResponse({ ...response, textContent: text })
            }
            style={[AppStyles.basicTextInput, { height: 100, marginBottom: 6 }]}
          />
          <Button
            onPress={() => {
              submitResponse().catch(error => console.error("Error submitting response"));
            }}
            title="Submit"
          />
        </>
      )}
    </View>
  );
};
